import { Box, Typography } from '@mui/material';
import React from 'react';

import tagsImage from 'assets/images/help-pdp-image-tags.png';
import sourcesImage from 'assets/images/help-pdp-image-sources.png';
import HelpImage from 'ui/help/HelpImage';

// TODO internationalize if we end up caring about it

const HelpImages = () => {
  return (
    <Box>
      <Typography variant='body1'>
        The product details page has an image carousel that has some useful
        information about where images are sourced, and where they will appear.
        In the example below, some tags have been pointed out that give some
        useful information. Here 'main' means that this is the main product
        image for this item, and it is what will be shown on a card view for an
        item in myUNFI. the myUNFI tag means that this is an image that will
        show up for myUNFI. Due to how our images are sourced, certain images
        won't always be shown, there is a set order of precedence in how we
        retrieve images and whether we end up displaying them to an end user or
        not
      </Typography>
      <HelpImage imageSrc={tagsImage} alt='image carousel tags' />
      <Typography variant='body1'>
        In our second example (the second image for the same product shown
        above), you can see that both the 'main' and 'myUNFI' tags are missing.
        This means that this product image is available for this product, but it
        won't be shown on the web portal, and it is a secondary image. There is
        also an arrow to the file path area; for some images that we locally
        source, this will show where this image is stored in case it ever needs
        to be modified
      </Typography>
      <HelpImage
        imageSrc={sourcesImage}
        alt='image carousel sources and no tags'
      />
    </Box>
  );
};

export default HelpImages;
